export default {"src":"/_next/static/media/current_projects.f15c43a8.svg","height":500,"width":500};